module.exports = ".full-width {\n  width: 100%; }\n\n.mat-table-container {\n  overflow: auto; }\n\ntable[td-data-table] .td-data-table-cell, table[td-data-table] .td-data-table-column {\n  padding: 0 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/hojadeseguimiento.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/hojadeseguimiento.component.scss
// module chunks = main